import { ConversationHistoryPeriod, type TicketAsset } from "./types";

export const avaPeriods: Record<ConversationHistoryPeriod, string> = {
  [ConversationHistoryPeriod.TODAY]: "Today",
  [ConversationHistoryPeriod.PREV_7]: "Previous 7 days",
  [ConversationHistoryPeriod.PREV_30]: "Previous 30 days",
  [ConversationHistoryPeriod.OLDER]: "Over 30 days",
};

export const CHIP_TEXT_MAX_WIDTH = 90;
export const CHIP_WIDTH = CHIP_TEXT_MAX_WIDTH + 54;
export const NO_PROJECT_ASSET: TicketAsset = {
  asset: "no_project",
  identifier: "No project, general question",
  label: "No project, general question",
};

export const ASSET_NOT_REQUIRED = [
  "cloud_management_platform",
  "credits___request",
  "finance___billing",
  "perfectscale",
];
